import React from 'react';
import './HeaderAbout.css';

import Contact from '../Contact/Contact';

function HeaderAbout(props) {
  return (
    <div className="HeaderAbout">
      <div className="Name">
        <div className="Left">
          <h1>ayy</h1>
          <h5>austin</h5>
        </div>
        <div className="Right">
          <h1>fish</h1>
          <h5>fisher</h5>
        </div>
      </div>
      <Contact/>
    </div>
  );
}

export default HeaderAbout;



// WEBPACK FOOTER //
// ./src/components/HeaderAbout/HeaderAbout.js